import React from "react";
import { ThemeProvider } from "styled-components";
import { myTheme } from "./services/styles/theme";
import LinkAccount from "./components/LinkAccount";

function App({ sfmcDetails, invalidJwt }) {
  return (
    <ThemeProvider theme={myTheme}>
      <div className="App">
        <LinkAccount sfmcDetails={sfmcDetails} invalidJwt={invalidJwt} />
      </div>
    </ThemeProvider>
  );
}

export default App;
